import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ShowNotificationModal = ({ show, onHide, selectedItem, handleDelete }) => {
  return (
    <Dialog open={show} onClose={onHide} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add Notifications
        <IconButton
          aria-label="close"
          onClick={onHide}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Notification Type"
            size="small"
            value={selectedItem.notification_type.type}
            disabled
            fullWidth
          />
          <TextField
            label="Custom Title"
            size="small"
            value={selectedItem.custom_title}
            disabled
            fullWidth
          />
          <TextField
            label="Custom Data"
            size="small"
            value={selectedItem.custom_data}
            multiline
            disabled
            fullWidth
          />
          <TextField
            label={
              selectedItem.notification_type.type === "APPOINTMENT_REMINDER"
                ? "Days-Before"
                : "Days-After"
            }
            size="small"
            type="number"
            value={
              selectedItem.notification_type.type === "APPOINTMENT_REMINDER"
                ? selectedItem.days_before
                : selectedItem.days_after
            }
            disabled
            fullWidth
          />

          <Typography variant="subtitle2">Notification</Typography>
          <Stack direction="row" spacing={2}>
            <FormControlLabel
              control={<Checkbox checked={selectedItem.IsApp === true} disabled />}
              label="In App"
            />
            <FormControlLabel
              control={<Checkbox checked={selectedItem.IsSMS === true} disabled />}
              label="SMS"
            />
            <FormControlLabel
              control={<Checkbox checked={selectedItem.IsEmail === true} disabled />}
              label="Email"
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={handleDelete}>
          Delete
        </Button>
        <Button variant="outlined" onClick={onHide}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowNotificationModal;
